export const getUserByAuth0Id = "getUserByAuth0Id";
export const getCurrentUserProfile = "getCurrentUserProfile";
export const getCurrentUsersDevices = "getCurrentUsersDevices";
export const getRelationships = "getRelationships";
export const getSpecialties = "getSpecialties";
export const getShareHistory = "getShareHistory";
export const postShareHistory = "postShareHistory";
export const getLatestReadingsForDevice = "getLatestReadingsForDevice";

// Wordle
export const attemptedWord = "attemptedWord";
export const createWordleGame = "createWordleGame";
export const getAllGuessedWords = "getAllGuessedWords";
export const getAllWordleWords = "getAllWordleWords";
export const getWordleGameRecord = "getWordleGameRecord";
export const getWordleWordOfTheDay = "getWordleWordOfTheDay";
export const saveWordForRow = "saveWordForRow";
export const setWordleGameId = "setWordleGameId";
export const updateAttemptedGuesses = "updateAttemptedGuesses";
export const updateGameWon = "updateGameWon";
export const updateLettersGuessed = "updateLettersGuessed";
export const updateWordleGame = "updateWordleGame";
export const updateWordleStreaks = "updateWordleStreaks";
